module.exports = __webpack_public_path__ + "static/media/band.ca2da0d5.svg";